import { Controller } from 'stimulus'

/**
 * Manages js for dependent fields (StimulusJS controller)
 *
 *
 * @example
 *
 * .container{ data: { controller: 'dependent-field' } }
 *
 *   .multi-form__fields
 *     .multi-form__options
 *       %span
 *         = button ...
 *         = radio_button_tag :field_name, .. data: { target: 'dependent-field.trigger', action: 'input->dependent-field#toggle' }
 *
 * @class DependentFieldController
 * @memberof Controllers
 */
export default class extends Controller {
  static targets = [ 'togglable', 'trigger' ]

  /**
   * @function controllers.DependentFieldController.initialize
   * @memberof controllers
   * @description triggers toggleVisibility on load to ensure proper state.
   *
   * @return {undefined} manipulates the dom.
   *
   */
  initialize() {
    this.toggleVisibility()
  }

  /**
   * @function controllers.DependentFieldController.toggle
   * @memberof controllers
   * @description triggers toggleVisibility on user event.
   *
   * @param {Event} event - Event from user interaction
   *
   * @return {undefined} manipulates the dom.
   *
   */
  toggle(event) {
    this.toggleVisibility()
  }

  /**
   * @function controllers.DependentFieldController.toggleVisibility
   * @memberof controllers
   * @description Toggles visibility of dependent fields upon dependent field
   * value
   *
   * @return {undefined} manipulates the dom.
   *
   */
  toggleVisibility() {
    let triggered = false
    this.triggerTargets.forEach(trigger => {
      if (trigger.checked === false || trigger.value === '') {
        return
      }
      triggered = true
      this.togglableTargets.forEach(togglable => {
        let dependentValues = togglable.dataset.dependentFieldOn
        if (dependentValues.includes(trigger.value)) {
          togglable.classList.remove('form__fields--hidden')
        } else {
          togglable.classList.add('form__fields--hidden')
        }
      })
    })
    if (triggered === false) {
      this.togglableTargets.forEach(togglable => {
        togglable.classList.add('form__fields--hidden')
      })
    }
  }
}
